import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AccessGateScreen } from "./../AccessGateScreen";

export const NotPartnerScreen: FC = () => {
  const { t } = useTranslation();
  return (
    <AccessGateScreen
      title={t("auth.notPartner.title")}
      text={t("auth.notPartner.text")}
    />
  );
};
